// Collection page custom functionality
window.addEventListener('load', () => {
  if (typeof Collection !== 'undefined') {
    MinimogTheme.Collection = new Collection();
    MinimogTheme.Collection.init();
  }

  // Lock columns to 4 always
  setTimeout(() => {
    if (MinimogTheme.Collection) {
      const originalToggleView = MinimogTheme.Collection.toggleView;
      MinimogTheme.Collection.toggleView = function(col) {
        originalToggleView.call(MinimogTheme.Collection, 4);
      };
      MinimogTheme.Collection.updateViewByScreen = function() {};
      MinimogTheme.Collection.toggleView(4);
      window.localStorage.setItem('gridColumnViews', 4);
    }
  }, 100);
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (typeof Collection !== 'undefined') {
      MinimogTheme.Collection.init();
    }
  });
}